function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GENERATEBALANCES_REQUEST = "GENERATEBALANCES_REQUEST";
export var GENERATEBALANCES_SUCCESS = "GENERATEBALANCES_SUCCESS";
export var GENERATEBALANCES_FAILURE = "GENERATEBALANCES_FAILURE";
export var RESET_GENERATEBALANCES = "RESET_GENERATEBALANCES";
export var generateBalances = function generateBalances(fromInstant, toInstant, forceUpdate, balanceClassNames, boostIds, brokerIds, currencyIds, goalIds, investmentItemIds, userIds) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      fromInstant: fromInstant,
      toInstant: toInstant,
      forceUpdate: forceUpdate,
      balanceClassNames: balanceClassNames,
      boostIds: boostIds,
      brokerIds: brokerIds,
      currencyIds: currencyIds,
      goalIds: goalIds,
      investmentItemIds: investmentItemIds,
      userIds: userIds
    });
    return dispatch(_defineProperty({}, CALL_API, {
      types: [GENERATEBALANCES_REQUEST, GENERATEBALANCES_SUCCESS, GENERATEBALANCES_FAILURE],
      endpoint: "balances/generate".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var ABORTGENERATEBALANCES_REQUEST = "ABORTGENERATEBALANCES_REQUEST";
export var ABORTGENERATEBALANCES_SUCCESS = "ABORTGENERATEBALANCES_SUCCESS";
export var ABORTGENERATEBALANCES_FAILURE = "ABORTGENERATEBALANCES_FAILURE";
export var RESET_ABORTGENERATEBALANCES = "RESET_ABORTGENERATEBALANCES";
export var abortGenerateBalances = function abortGenerateBalances() {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, CALL_API, {
      types: [ABORTGENERATEBALANCES_REQUEST, ABORTGENERATEBALANCES_SUCCESS, ABORTGENERATEBALANCES_FAILURE],
      endpoint: "balances/abortGenerate",
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var GET_GENERATEBALANCESCONTEXT_REQUEST = "GET_GENERATEBALANCESCONTEXT_REQUEST";
export var GET_GENERATEBALANCESCONTEXT_SUCCESS = "GET_GENERATEBALANCESCONTEXT_SUCCESS";
export var GET_GENERATEBALANCESCONTEXT_FAILURE = "GET_GENERATEBALANCESCONTEXT_FAILURE";
export var RESET_GET_GENERATEBALANCESCONTEXT = "RESET_GET_GENERATEBALANCESCONTEXT";
export var loadGenerateBalancesContext = function loadGenerateBalancesContext() {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({}, CALL_API, {
      types: [GET_GENERATEBALANCESCONTEXT_REQUEST, GET_GENERATEBALANCESCONTEXT_SUCCESS, GET_GENERATEBALANCESCONTEXT_FAILURE],
      endpoint: "balances/generateContext",
      init: {
        credentials: "same-origin"
      }
    }));
  };
};
export var GET_BALANCES_REQUEST = "GET_BALANCES_REQUEST";
export var GET_BALANCES_SUCCESS = "GET_BALANCES_SUCCESS";
export var GET_BALANCES_FAILURE = "GET_BALANCES_FAILURE";
export var loadBalances = function loadBalances(page, size, idFilterValue, userIdFilterValue, startDateFilterValue, endDateFilterValue) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      page: page,
      size: size,
      sort: "instant,desc",
      idFilterValue: idFilterValue,
      userIdFilterValue: userIdFilterValue,
      startDateFilterValue: startDateFilterValue,
      endDateFilterValue: endDateFilterValue
    });
    return dispatch(_defineProperty({}, CALL_API, {
      types: [GET_BALANCES_REQUEST, GET_BALANCES_SUCCESS, GET_BALANCES_FAILURE],
      endpoint: "balances/search/findAll".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};